module.exports = __webpack_public_path__ + "static/fonts/iconfont.017f35c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/iconfont.woff?t=1602470866315
// module id = TSpz
// module chunks = 1